import React, { useState, useEffect } from 'react';
import { connect, useDispatch } from "react-redux";
import { authActions } from '../_actions';
import { withRouter } from '../_helpers/withRouter';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser, faKey } from '@fortawesome/free-solid-svg-icons'
import { Button, Form, FormGroup } from 'reactstrap';
import { Link } from '@mui/material';
import './styles.css';

const Login = (props) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [state, setState] = useState('');

    useEffect(() => {
        var data_hoje = new Date().getTime();
        if (localStorage.getItem('expire') === undefined || localStorage.getItem('expire') < data_hoje) {
            dispatch(authActions.logout(false, navigate));
        } else {
            navigate('/home');
        }
    }, [navigate, dispatch]);

    const handleChangeUsername = prop => event => {
        setUsername(event.target.value);
    };

    const handleChangePassword = prop => event => {
        setPassword(event.target.value);
    };

    const handleValidation = () => {

        var valid = true;
        var errors = '';

        if (username === null || username === '') {
            valid = false;
            errors += '<li style="float:left;">Preencha o usuário!</li><br>';
        }
        if (password === null || password === '') {
            valid = false;
            errors += '<li style="float:left;">Preencha a senha!</li><br>';
        }
        else {
            if (username && password) {
                dispatch(authActions.login(username, password, navigate));
            }
        }

        if (!valid) {

            Swal.fire({
                icon: 'warning',
                title: 'Erros de validação',
                showCloseButton: true,
                showConfirmButton: true,
                html: '<div style="font-size: 14px; text-align: left"><ul>' + errors + '</ul></div>'
            });
        }
        return valid;
    };


    const login = () => {
        setState({ submitted: true });
        const { dispatch } = props;
        handleValidation()
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            login();
        }
    }

    return (
        <div id="page-content">
            <div id="">
                <div className="container text-center">
                    <div className="row justify-content-center form_container">
                        <div className="user_card">
                            <div className="d-flex justify-content-center brand_img">
                                <img src={require('../imgs/banner_gestor_rp.png')} height="85" className="brand_logo" alt="logoRP" />
                            </div>
                            <div className="d-flex justify-content-center">
                                <Form>
                                    <FormGroup className="input-group mb-3">
                                        <div className="input-group-append">
                                            <span className="input-group-text"><FontAwesomeIcon icon={faUser} /></span>
                                        </div>
                                        <input type="text" autoFocus ref={state.username}
                                            name="usuario" value={state.username} className="form-control" onChange={handleChangeUsername('username')}
                                            placeholder="usuário" />
                                    </FormGroup>
                                    <FormGroup className="input-group mb-2">
                                        <div className="input-group-append">
                                            <span className="input-group-text"><FontAwesomeIcon icon={faKey} /></span>
                                        </div>
                                        <input type="password" ref={state.password}
                                            autoComplete="current-password"
                                            value={state.password} onKeyDown={handleKeyDown} className="form-control" onChange={handleChangePassword('password')}
                                            placeholder="senha" />
                                    </FormGroup>
                                    <div className="d-flex justify-content-center mt-3 login_container">
                                        <Button block className="login_btn" onClick={() => { login() }} >Login</Button>
                                    </div>
                                    <div className="d-flex justify-content-center mt-3 mb-2 login_container">
                                        <Link href="javascript:;" onClick={() => navigate("/request-password-reset")} variant="body2">
                                            Esqueceu a senha?
                                        </Link>
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    );
}


const mapStateToProps = (state) => {
    const { loggingIn } = state.authentication;
    return {
        loggingIn
    };
}
const connectedLoginPage = withRouter(connect(mapStateToProps, null, null, {
    pure: false
})(Login));

export { connectedLoginPage as Login };
